













































import VueMarkdown from 'vue-markdown'
import { Mixins, Component, Prop, Emit } from 'vue-property-decorator'
import { ToiawaseFileUpload } from '@/tcw/api/types'
import { FromValueType } from '@/components/common/form/types'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'
import TcwFormItem from '@/components/common/form/TcwFormItem.vue'
import { AddFileInfo } from '@/components/help/types'
import { FileListItem } from 'element-ui/types/upload'

export interface AutoSize {
  minRows: number
  maxRows: number
}

@Component({
  components: { TcwFormItem, VueMarkdown }
})
export default class ToiawaseMarkdownForm extends Mixins(TcwFormItemCommon) {
  @Prop({ default: '' })
  private value!: string
  @Prop({ default: 10 })
  private rows!: number
  @Prop({ default: 10 })
  private minRows!: number
  @Prop({ default: 10 })
  private maxRows!: number
  @Prop({ default: () => [] })
  private fileList!: ToiawaseFileUpload[]
  @Prop({ type: Boolean, default: false })
  private uploading!: boolean

  @Emit()
  private input(_value: FromValueType) {
    //
  }

  @Emit()
  private addFiles(_addFiles: AddFileInfo) {
    //
  }

  private preview = 'input'

  private get autosize(): AutoSize {
    const minRows = this.minRows ? this.minRows : this.rows
    let maxRows = this.maxRows ? this.maxRows : this.rows
    if (minRows > maxRows) {
      maxRows = minRows
    }
    return { minRows, maxRows }
  }

  private addFileProc(addFiles: File[]) {
    if (addFiles.length > 0) {
      let cursorIndex = this.value.length
      const texteareaEl = (this.$refs.textarea as Vue)?.$el.getElementsByTagName('textarea')
      if (texteareaEl && texteareaEl.length > 0) {
        cursorIndex = texteareaEl[0].selectionStart
      }
      this.addFiles({
        cursorIndex,
        files: addFiles,
        length: addFiles.length
      })
    }
  }

  private handlePasteEvent(event: ClipboardEvent) {
    // console.log(`paste event handle: ${event.type}`)
    if (!event.clipboardData) {
      return
    }

    // クリップボードのファイル情報を取得する
    const files: File[] = []
    event.clipboardData.types.forEach((t, i) => {
      if (t !== 'Files') {
        return
      }
      const pasteFile = event.clipboardData?.items[i].getAsFile()
      if (!pasteFile) {
        return
      }
      files.push(pasteFile)
    })

    // イベント発火する
    this.addFileProc(files)
  }

  private get markdownFormItemStyle(): { [key: string]: string } {
    const style = this.formItemStyle
    style['position'] = 'relative'
    return style
  }

  private get markdownStyle(): { [key: string]: string } {
    return {
      width: '100%',
      height: this.markdownHeight,
      padding: '5px 15px',
      border: '1px solid #DCDFE6',
      'border-radius': '4px',
      'background-color': '#f0f8ff',
      'overflow-y': 'auto'
    }
  }

  private get markdownHeight(): string {
    if (!this.preview) {
      return ''
    }

    const textareaRef = this.$refs.textarea as Vue
    if (!textareaRef) {
      return ''
    }
    return textareaRef.$el.scrollHeight + 'px'
  }

  private get markdownText(): string {
    // 添付ファイルのURLを絶対パスに変換
    let text = String(this.value)
    this.fileList.forEach(f => (text = text.replaceAll(f.url, f.absUrl)))
    return text
  }

  private get uploadFileList(): FileListItem[] {
    return this.fileList.map(f => {
      return {
        name: f.name,
        url: f.absUrl
      }
    })
  }
}
